import { createRoot } from 'react-dom/client';
import UserLocation from './components/location/UserLocation';
import './styles/main.scss';

// Keep track of initialized instances
const initializedInstances = new Set();

// Initialize User Location apps
function initUserLocationApps() {
    // Check if we have user location configurations
    if (typeof window.gwBpUserLocationConfig !== 'undefined') {
        Object.keys(window.gwBpUserLocationConfig).forEach(instanceId => {
            // Skip if already initialized
            if (initializedInstances.has(instanceId)) {
                return;
            }
            
            const container = document.getElementById(instanceId);
            if (container) {
                const config = window.gwBpUserLocationConfig[instanceId];
                const strings = window.gwBpUserLocationAjax?.strings || {};
                
                const root = createRoot(container);
                root.render(
                    <UserLocation 
                        config={config} 
                        strings={strings}
                    />
                );
                
                initializedInstances.add(instanceId);
            }
        });
    }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUserLocationApps);
} else {
    initUserLocationApps();
}

// Also check for late-loaded configurations
if (typeof window !== 'undefined') {
    // Watch for new configurations being added
    let checkCount = 0;
    const checkForNewConfigs = () => {
        if (checkCount > 10) return; // Stop after 10 attempts
        
        if (typeof window.gwBpUserLocationConfig !== 'undefined') {
            initUserLocationApps();
        } else {
            checkCount++;
            setTimeout(checkForNewConfigs, 100);
        }
    };
    
    setTimeout(checkForNewConfigs, 100);
}
